export default "__VITE_ASSET__da13da15__"